module.exports = __webpack_public_path__ + "img/3.4eb773b5.jpg";